import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { applications } from 'src/app/shared/utils';
import { SwitchAppService } from 'src/app/switch-app.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  _csrf?: string;
  ticket?: string;
  email?: string;

  clientId: string;
  applications = applications();

  constructor(
    activatedRoute: ActivatedRoute,
    private resolve: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    private switchApp: SwitchAppService
  ) {
    this._csrf = document.querySelector<HTMLInputElement>('#_csrf')?.value;
    this.ticket = document.querySelector<HTMLInputElement>('#ticket')?.value;
    this.email = document.querySelector<HTMLInputElement>('#email')?.value;
    activatedRoute.queryParams.subscribe((query) => {
      this.clientId = query['client_id'];
    });
    const app = this.applications.find((e) => e.clientId === this.clientId);
    if (app) {
      this.switchApp.setComponent(
        this.clientId,
        app.type,
        viewContainerRef,
        resolve,
        'resetPassword',
        { _csrf: this._csrf, email: this.email, ticket: this.ticket }
      );
    }
  }

  get isStation(): boolean {
    return /dstation/g.test(
      this.applications.find((app) => app.clientId === this.clientId).type
    );
  }

  ngOnInit(): void {}
}
